import { cn } from '@plato/ui/util/classes';
import type { CSSProperties, ForwardedRef, PropsWithChildren } from 'react';
import React from 'react';

type Props = {
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
} & PropsWithChildren;

export const DashboardSection = React.forwardRef<HTMLDivElement, Props>(
    ({ className = '', onClick, style, children, ...rest }, ref: ForwardedRef<HTMLDivElement>) => {
        return (
            <div
                onClick={onClick}
                ref={ref}
                className={cn('flex w-full flex-col rounded-md border border-neutral-200 p-3', className)}
                style={style}
                {...rest}
            >
                {children}
            </div>
        );
    },
);

DashboardSection.displayName = 'DashboardSection';
